import UsingForm from '@/presentation/components/forms/CreatePositionForms/UsingForm';
import { UsingFormFields } from '@/presentation/components/forms/CreatePositionForms/UsingForm/types';
import { Address } from 'nftx.js';
import { Dispatch, ReactNode, useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';

const Using = ({
  collection,
  collectionName,
  symbol,
  vaultId,
  using: initialUsing,
  dispatch,
  onSubmit,
  Sidebar,
}: {
  collection: Address;
  collectionName: string;
  symbol: string;
  vaultId: string;
  using: 'nft' | 'vtoken';
  onSubmit: () => void;
  dispatch: Dispatch<Partial<UsingFormFields>>;
  Sidebar: ReactNode;
}) => {
  const { control, handleSubmit } = useForm<UsingFormFields>({
    defaultValues: { using: initialUsing },
  });
  const { using } = useWatch({ control });

  useEffect(() => {
    dispatch({ using });
  }, [dispatch, using]);

  const onFormSubmit = handleSubmit((values) => {
    dispatch(values);
    onSubmit();
  });

  return (
    <form
      className="grid grid-cols-2 md:grid-cols-3 gap-8 relative"
      onSubmit={onFormSubmit}
    >
      <div className="md:col-span-2">
        <UsingForm
          collection={collection}
          collectionName={collectionName}
          control={control}
          size="normal"
          symbol={symbol}
          using={using}
          vaultId={vaultId}
        />
      </div>
      {Sidebar}
    </form>
  );
};

export default Using;
